const axios = require('axios');

const CONFIG = {
  timeout: 15000,
  baseURL: process.env.EVENTS_APP_BACKEND_URL || process.env.VUE_APP_EVENTS_BACKEND_URL || process.env.VITE_EVENTS_BACKEND_URL,
  contentType: 'application/json'
};

module.exports = axios.create(CONFIG);
